import * as React from "react";

var NavHeader = function NavHeader(props) {
  var activeStep = props.activeStep,
      onChangeStep = props.onChangeStep;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 navHeader"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "nav nav-pills"
  }, /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(activeStep === 1 ? "active" : ""),
    onClick: function onClick() {
      return onChangeStep(1);
    }
  }, "1. Ingreso Siniestro")), /*#__PURE__*/React.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/React.createElement("a", {
    className: "nav-link ".concat(activeStep === 2 ? "active" : ""),
    onClick: function onClick() {
      return onChangeStep(2);
    }
  }, "2. Liquidador"))));
};

export default NavHeader;